import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types'; // Import PropTypes for validation
import Geforce1 from '../images/avatar-the-optimizer.png'; // Import your images
import Geforce2 from '../images/avatar-the-strategist.png';
import Geforce3 from '../images/avatar-the-seeker.png';
import Geforce4 from '../images/avatar-the-innovator.png';

const OppositeDirectionNew = ({ index }) => {
    const [position, setPosition] = useState({ top: 0, left: 0 });
    const [imageIndex, setImageIndex] = useState(0); // Image index for cycling
    const [fade, setFade] = useState(true); // For fade in/out effect
    const imageRef = useRef(null);

    const images = [
        Geforce1, Geforce2, Geforce3, Geforce4 // Use 4 images
    ];

    // Cycle through images every 2 seconds (adjust time as needed)
    useEffect(() => {
        const interval = setInterval(() => {
            setFade(false); // Start fading out
            setTimeout(() => {
                setImageIndex((prevIndex) => (prevIndex + 1) % images.length); // Increment index and loop back
                setFade(true); // Start fading in after image change
            }, 500); // Half a second for fade-out, adjust as needed
        }, 2000); // 2 seconds per image

        return () => clearInterval(interval); // Clean up on component unmount
    }, []);

    const handleMouseMove = (e) => {
        if (imageRef.current) {
            const rect = imageRef.current.getBoundingClientRect();
            const imageCenter = {
                x: rect.left + rect.width / 2,
                y: rect.top + rect.height / 2,
            };

            const offset = {
                x: (e.clientX - imageCenter.x) * -0.1,
                y: (e.clientY - imageCenter.y) * -0.1,
            };

            setPosition({
                top: offset.y,
                left: offset.x,
            });
        }
    };

    const handleMouseLeave = () => {
        setPosition({ top: 0, left: 0 });
    };

    return (
        <div
            onMouseMove={handleMouseMove}
            onMouseLeave={handleMouseLeave}
            className="flex justify-center items-center h-full relative w-full"
        >
            <img
                src={images[imageIndex]} // Cycles through the 4 images
                alt={`image-${imageIndex + 1}`} // Adjust alt text
                ref={imageRef}
                className="relative lg:absolute z-0 scale-75"
                style={{
                    transition: 'transform 0.3s ease-out, opacity 0.5s ease-in-out',
                    transform: `translate(${position.left}px, ${position.top}px)`,
                    opacity: fade ? 1 : 0, // Apply fade in/out effect
                }}
            />
        </div>
    );
};

// Define prop types and default values
OppositeDirectionNew.propTypes = {
    index: PropTypes.number
};

OppositeDirectionNew.defaultProps = {
    index: 0
};

export default OppositeDirectionNew;
